//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import md5 from 'js-md5'
import store from '@/store'                    // 引入vuex数据
import Register from './register'
import ForgetPassword from './forget-password'
import SmsLogin from './sms-login'
import {getQueryVariable} from '../../../assets/js/utils'
import i18n from '../../../assets/locale/'
import {WECHAT_JUMP_TEST} from "../../../assets/api/common/api-constant";

export default {
  name: 'leon-simple-login',
  i18n,
  components: {
    Register,
    ForgetPassword,
    SmsLogin
  },
  data () {
    return {
      isShow: true,  // 控制显示隐藏
      showType: 'login',
      phone: '',     // 手机号码
      password: ''  // 密码
      // canPush: false // 能否登录
    }
  },
  mounted () {
    window.localStorage.removeItem('userData')
    store.commit('set_login_bol', false)
  },
  methods: {
    // 跳转微信授权
    wechatJump () {
      this.$utils.sessionCache('wechatRedirectUrl', window.location.href)
      let arr = window.location.href.split('#/')
      let data = {
        // callbackUrl: window.location.href.split('/#/')[1]
        callbackUrl: arr[1] || ''
      }
      // WECHAT_JUMP_TEST 测试登录
      let str = 'WECHAT_JUMP'
      // if (window.location.href.includes('webloom.cn')) {
      //
      // } else {
      //   str = 'WECHAT_JUMP_TEST'
      //   data = {
      //     // callbackUrl: window.location.href.split('/#/')[1]
      //     callbackUrl: window.location.href
      //   }
      // }
      this.$api.post(str, data, (res) => {
        window.location.href = res.data
      })
    },
    // 打开短信登录
    showSmsLogin () {
      this.showType = 'smsLogin'
    },
    btn () {
      // this.validate(true)
      if (!this.canPush) {
        return
      }
      let data = {}
      data.phone = this.phone
      data.password = md5(this.password)
      let qr = 'USER_LOGON'

      if (getQueryVariable('openId')) {
        qr = 'WECHAT_LOGIN'
        data.openId = getQueryVariable('openId')
      }
      this.$api.post(qr, data, res => {
        this.$utils.cache('userData', JSON.stringify(res.data))
        this.$utils.cache('loginState', true)
        store.commit('set_login_bol', true)
        this.close()
        window.location.reload()
      })
    },
    // 关闭登录框
    close () {
      this.isShow = false
    },
    // 跳转
    goToRegister () {
      this.showType = 'register'
    },
    goToForgetPsd () {
      this.showType = 'forget'
    },
    showLogin () {
      this.showType = 'login'
    },
    toggleContainerTouchAction (v) {
      const container = document.querySelector('#SimpleLogin')
      if (!container) {
        return
      }
      container.style['touch-action'] = v ? 'none' : 'auto'
    },
    stopTouch (e) {
      e.preventDefault()
    }
  },
  watch: {
    isShow: {
      handler (v) {
        console.warn('变化了', v)
        this.toggleContainerTouchAction(v)
        if (v) {
          document.body.addEventListener('touchmove', this.stopTouch, { passive: false, capture: true })
        } else {
          document.body.removeEventListener('touchmove', this.stopTouch, { capture: true })
        }
      },
      immediate: true
    }
  },
  computed: {
    canPush () {
      return this.phone && this.password.length >= 6
    }
  }
  // watch: {
  //   phone (val) {
  //     this.validate()
  //   },
  //   password (val) {
  //     this.validate()
  //   }
  // }
}



// WEBPACK FOOTER //
// ./src/plugin/LeonSimpleLogin/src/main.vue